export const isShallowIdentical = (currentStateValue: any, payload: any) => {
  return JSON.stringify(currentStateValue) === JSON.stringify(payload);
};
